import { useMemo } from "react";
import PropTypes from "prop-types";
import { FormattedMessage } from "react-intl";
import messages from "./messages";
import { Grid, Typography } from "@material-ui/core";
import { makeStyles } from "@material-ui/core/styles";
import moment from "moment";
import RefrezhButton from "components/RefrezhButton";
import { withRouter } from "react-router";
import Base from "components/Message/Base";

const useStyles = makeStyles(theme => ({
  header: {
    display: "flex",
    justifyContent: "space-between",
    alignItems: "center",
  },
  poDetails: {
    borderBottom: "1px solid rgba(0,0,0,0.46)",
    paddingBottom: theme.spacing(2),
  },
  content: {
    padding: theme.spacing(2, 0),
  },
  actionContainer: {
    display: "flex",
    justifyContent: "center",
    alignItems: "center",
    borderTop: "1px solid rgba(0,0,0,0.46)",
    padding: theme.spacing(2),
  },
  marginTop: {
    marginTop: theme.spacing(2),
  },
  marginSides: {
    margin: theme.spacing(0, 2),
  },
  messageBox: {
    borderLeft: "none",
    border: "1px solid rgba(0,0,0,0.24)",
    borderColor: "rgba(0,0,0,0.24)",
  },
  stlConfirm: {
    marginLeft: "auto",
    marginRight: "auto",
    textAlign: "center",
  },
  confirmButton: {
    marginTop: theme.spacing(2),
  },
}));

function OrderIncomplete({
  activeMessage = {},
  onClose,
  history,
  showPatient,
}) {
  const classes = useStyles();

  const body = useMemo(
    () => (
      <div className={classes.body}>
        <Grid container className={classes.poDetails}>
          <Grid item xs={12} sm={6}>
            <Typography variant="caption">
              <FormattedMessage {...messages.order_placed_upper_product} />
            </Typography>
            <Typography variant="subtitle1">
              {activeMessage.productOrder.upperProductName}
            </Typography>
          </Grid>
          <Grid item xs={12} sm={6}>
            <Typography variant="caption">
              <FormattedMessage {...messages.order_placed_lower_product} />
            </Typography>
            <Typography variant="subtitle1">
              {activeMessage.productOrder.lowerProductName}
            </Typography>
          </Grid>
        </Grid>
        <div className={classes.content}>
          <Typography variant="body1">
            <FormattedMessage
              {...messages.incomplete_order}
              values={{
                caseNumber: activeMessage.productPlan.caseId,
              }}
            />
          </Typography>
          <div className={classes.stlConfirm} data-cy="STLButton">
            <RefrezhButton
              disabled={activeMessage.status === 2}
              onClick={() => {
                history.push(
                  `/order/patient/${activeMessage.patient.id}/treatment/${
                    activeMessage.productOrder.id
                  }`,
                );
              }}
              className={classes.confirmButton}
            >
              {activeMessage.status === 2 ? (
                <FormattedMessage
                  {...messages.upload_stl_done}
                  values={{
                    date: moment
                      .unix(activeMessage.updatedAt)
                      .format("DD-MM-YYYY"),
                  }}
                />
              ) : (
                <FormattedMessage {...messages.upload_stl_confirm} />
              )}
            </RefrezhButton>
          </div>
        </div>
      </div>
    ),
    [
      activeMessage.patient,
      activeMessage.productOrder.id,
      activeMessage.productOrder.lowerProductName,
      activeMessage.productOrder.upperProductName,
      activeMessage.productPlan.caseId,
      activeMessage.status,
      activeMessage.updatedAt,
      classes.body,
      classes.confirmButton,
      classes.content,
      classes.poDetails,
      classes.stlConfirm,
      history,
    ],
  );

  return (
    <Base
      onClose={onClose}
      title={<FormattedMessage {...messages.order_incomplete} />}
      activeMessage={activeMessage}
      shouldRenderPatient={showPatient}
    >
      {body}
    </Base>
  );
}

OrderIncomplete.propTypes = {
  activeMessage: PropTypes.shape({
    stlFileURL: PropTypes.string,
    updatedAt: PropTypes.number,
    productOrder: PropTypes.shape({
      lowerProductName: PropTypes.string,
      upperProductName: PropTypes.string,
      phase: PropTypes.string,
      avadentCaseId: PropTypes.string,
      deliveryDate: PropTypes.number,
    }),
    productPlan: PropTypes.shape({
      caseId: PropTypes.string,
    }),
    patient: PropTypes.shape({
      id: PropTypes.number,
    }),
  }),
  onClose: PropTypes.func.isRequired,
  onCloseMessage: PropTypes.func.isRequired,
};

export default withRouter(OrderIncomplete);
